import React from "react";
import { RiCon, RiHe, RiHea, RiPa, RiUl, RiWra } from "./Rights.elements";

const Rights = () => {
  return (
    <RiWra>
      <RiCon>
        {/* العنوان الرئيسي وتاريخ النفاذ */}
        <RiHe>سياسة الدورات لموقع dralsallum.com</RiHe>
        <RiPa>تاريخ النفاذ: 6 يوليو 2025</RiPa>

        {/* تنبيه مالي */}
        <RiHea>التنبيه المالي</RiHea>
        <RiPa>
          جميع الرسوم المدفوعة مقابل الدورات نهائية{" "}
          <strong>وغير قابلة للاسترداد</strong> تحت أي ظرف.
        </RiPa>

        {/* التعريفات */}
        <RiHea>التعريفات</RiHea>
        <RiUl>
          <li>
            الموقع: بوابة dralsallum.com وجميع الأنظمة التعليمية التابعة لها.
          </li>
          <li>المستخدم/المتعلم: كل شخص يسجل أو يستخدم خدمات الموقع.</li>
          <li>الدورات: البرامج التدريبية أو التعليمية المعروضة على الموقع.</li>
        </RiUl>

        {/* شروط التسجيل والاستخدام */}
        <RiHea>شروط التسجيل والاستخدام</RiHea>
        <RiUl>
          <li>تقديم معلومات صحيحة وحديثة عند إنشاء الحساب.</li>
          <li>الالتزام بجميع القوانين واللوائح المحلية والدولية ذات الصلة.</li>
          <li>عدم مشاركة بيانات الدخول أو السماح لغيرك باستخدام حسابك.</li>
        </RiUl>

        {/* سياسة الدفع وعدم الاسترداد */}
        <RiHea>سياسة الدفع وعدم الاسترداد</RiHea>
        <RiUl>
          <li>يُسدد المتعلم الرسوم كاملة قبل بداية الدورة.</li>
          <li>
            لا يحق للمتعلم المطالبة باسترداد الرسوم بعد إتمام عملية الدفع.
          </li>
          <li>
            إذا ألغت المنصة الدورة، يمكن تحويل الرسوم إلى دورة بديلة فقط دون
            استرجاع مالي.
          </li>
        </RiUl>

        {/* سياسة النزاهة الأكاديمية */}
        <RiHea>سياسة النزاهة الأكاديمية</RiHea>
        <RiPa>
          للاطلاع على السياسة الكاملة، يرجى زيارة&nbsp;
          <a
            href="https://dralsallum.com/integrity-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            رابط سياسة النزاهة
          </a>
          .
        </RiPa>

        {/* مفهوم النزاهة */}
        <RiHea>مفهوم النزاهة</RiHea>
        <RiPa>
          النزاهة الأكاديمية هي التزام المتعلم بالصدق والأمانة الفكرية في جميع
          أنشطته التعليمية.
        </RiPa>

        {/* أشكال انتهاك النزاهة */}
        <RiHea>أشكال انتهاك النزاهة</RiHea>
        <RiUl>
          <li>الغش بجميع صوره (مذكرات، أجهزة، مساعدة غير مصرّح بها).</li>
          <li>انتحال الشخصية (استخدام حساب أو هوية شخص آخر).</li>
          <li>استغلال التعاون خارج الحدود المسموح بها.</li>
          <li>التزوير أو التحريف في المستندات أو النتائج.</li>
        </RiUl>

        {/* الإجراءات والعقوبات */}
        <RiHea>الإجراءات والعقوبات</RiHea>
        <RiUl>
          <li>
            المخالفة الأولى: إنذار كتابي وإلغاء نتيجة التقييم محل المخالفة.
          </li>
          <li>المخالفة الثانية: إيقاف الحساب لمدة أسبوع.</li>
          <li>المخالفة الثالثة: إلغاء الاشتراك نهائيًا دون ردّ الرسوم.</li>
        </RiUl>

        {/* حماية البيانات والخصوصية */}
        <RiHea>حماية البيانات والخصوصية</RiHea>
        <RiUl>
          <li>
            نلتزم بنظام حماية البيانات الشخصية السعودي (PDPL) واستخدام بياناتك
            لأغراض تعليمية وتنظيمية فقط.
          </li>
          <li>لا نشارك بياناتك مع أطراف ثالثة دون موافقتك الصريحة.</li>
        </RiUl>

        {/* حقوق الملكية الفكرية */}
        <RiHea>حقوق الملكية الفكرية</RiHea>
        <RiUl>
          <li>
            جميع المحتويات (نصوص، فيديو، صور، شيفرة) مملوكة لـ dralsallum.com.
          </li>
          <li>أي استخدام تجاري أو إعادة توزيع يتطلب إذنًا خطيًا مسبقًا.</li>
        </RiUl>

        {/* التعديلات */}
        <RiHea>التعديلات</RiHea>
        <RiUl>
          <li>يجوز لنا تحديث هذه السياسة في أي وقت.</li>
          <li>
            يُعد استمرارك في استخدام الموقع بعد النشر قبولًا بالتعديلات الجديدة.
          </li>
        </RiUl>

        {/* القانون الحاكم وتسوية النزاعات */}
        <RiHea>القانون الحاكم وتسوية النزاعات</RiHea>
        <RiUl>
          <li>تخضع هذه السياسة لقوانين المملكة العربية السعودية.</li>
          <li>تُحل النزاعات أمام الجهات القضائية المختصة بمدينة الرياض.</li>
        </RiUl>

        {/* القبول */}
        <RiHea>القبول</RiHea>
        <RiUl>
          <li>
            باستخدامك للموقع أو التسجيل في أي دورة، تُقر بأنك قرأت هذه السياسة
            وفهمتها وتوافق على الالتزام بها.
          </li>
        </RiUl>

        {/* المستند المرفق */}
        <RiHea>المستند المرفق: آلية منع انتحال الهوية</RiHea>
        <RiPa>
          يمكن تحميل الوثيقة الكاملة عبر الرابط:&nbsp;
          <a
            href="https://dralsallum.com/files/identity_verification_procedure.txt"
            target="_blank"
            rel="noopener noreferrer"
          >
            تحميل آلية منع انتحال الهوية
          </a>
          .
        </RiPa>
      </RiCon>
    </RiWra>
  );
};

export default Rights;
